// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"3dd9cbe2","vendors-node_modules_react-bootstrap_esm_Badge_js-node_modules_react-bootstrap_esm_ButtonGrou-bc07ef":"ada71b32","administration":"dbcaf136"}[chunkId] + ".chunk.js";
};